/**
 * Static configuration values that are not intended to be changed by users.
 * These values were previously in config.json but have been moved here for better type safety
 * and to prevent user modification.
 */

import { CurrentJackpotDefinition, InfoMessagesDefinition } from "./GameConfig";

export const DEFAULT_INFO_MESSAGES: InfoMessagesDefinition = {
  x: 0,
  y: 0,
  width: 1920,
  height: 100,
  size: 50,
  color: "0xffffff",
  type: "scroll",
  cycle_interval: 5000,
  scroll_margin: 0,
  scroll_speed: 1,
  messages: [
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    "Ut vitae purus justo.",
    "Proin iaculis imperdiet velit, pharetra egestas orci mattis sit amet.",
    "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae",
    "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
  ],
};

export const DEFAULT_JACKPOT_HIT = {
  time_shown_seconds: 45,
  x: 1920 / 2 + 10,
  y: 594,
  size: 250,
  color: "0xf2e476",
  delay_show: 0,
  spin_duration: 5,
};

export const DEFAULT_CURRENT_JACKPOT = {
  time_shown_seconds: 30,
  jackpots: [
    {
      id: 10,
      x: 1920 / 2 + 10, //1145,
      y: 624,
      size: 250,
      color: "0xf2e476",
      delay_show: 1.3,
      spin_duration: 1.5,
      max_width: 1500,
      max_height: 0,
    },
  ] as CurrentJackpotDefinition[],
};

export const DEFAULT_HISTORY = {
  time_shown_seconds: 10,
  numrows: 10,
  showTimeInHistory: false,
  header: {
    font_size: 45,
    y: 0,
    color: "0xffffff",
  },
  rows: {
    start_y: 196,
    spacing_y: 93,
    date: {
      x: 50,
      y: 15,
      size: 35,
      color: "0xffffff",
      align: "left" as const,
    },
    location: {
      x: 380,
      y: -4,
      size: 50,
      color: "0xffffff",
      align: "left" as const,
    },
    win: {
      x: 1800,
      y: -8,
      size: 50,
      color: "0xfaf3aa",
      align: "right" as const,
    },
  },
};
